exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* green */\n\n/* new style guide green */\n\n/* Hover green primary button */\n\n/* Disabled green primary button */\n\n/* blue */\n\n/* blue 2 */\n\n/* New style guide blue primary button */\n\n/* Hover blue primary button */\n\n/* Disabled blue primary button */\n\n/* blue 3 */\n\n/* orange */\n\n/* orange 2 */\n\n/* red */\n\n/* red 2 */\n\n/* red 3 */\n\n/* teal */\n\n/* yellow */\n\n/* dark */\n\n/* tan */\n\n/* light brown */\n\n/* brown */\n\n/* dark brown/grey */\n\n/* white */\n\n/* dark */\n\n/* ligher */\n\n/* lightest */\n\n/* black */\n\n/* mid grey cancel/back button */\n\n/* Hover cancel/back button */\n\n/* Disabled cancel/back button */\n\n\n\n", ""]);

// Exports
exports.locals = {
	"grayDark": "#2e3033",
	"grey1": "#C4C4C4",
	"grey2": "#F5F5F5",
	"grey3": "#C2C2C2",
	"grey4": "#272727",
	"grey5": "#747474",
	"grey6": "#F0F0F0",
	"grey7": "#ADADAD",
	"grey8": "#EEEEEE",
	"grey9": "#CECECE",
	"primary1": "#7ca439",
	"primary1b": "#6ea436",
	"primary1c": "#4e7629",
	"primary1d": "#bee095",
	"primary2": "#599daa",
	"primary2b": "#4e7a28",
	"primary2c": "#599daa",
	"primary2d": "#427882",
	"primary2e": "#a0d2db",
	"primary2f": "#3A85C9",
	"primary3": "#ea843d",
	"primary3b": "#F6603C",
	"primary4": "#ea5e3e",
	"primary4b": "#BB4640",
	"primary4c": "#ec5d36",
	"primary5": "#57a98f",
	"primary6": "#FAFA90",
	"sec1": "#53534a",
	"sec2": "#a89f87",
	"sec3": "#7c6e66",
	"sec4": "#5f4f4f",
	"sec5": "#5e4f4f",
	"shade0": "#FFFFFF",
	"shade1": "#65656a",
	"shade2": "#8b8a8d",
	"shade3": "#e4e1dd",
	"shade4": "#f5f2e8",
	"shade5": "#000",
	"shade6": "#8b8a8d",
	"shade7": "#6b696e",
	"shade8": "#c7c6ca",
	"sliderContainerColor": "#374246",
	"sliderSelectionColor": "#80cbc4",
	"sliderBarColor": "#545d62",
	"sliderBarColor2": "#e4e1dd"
};